
         'use strict'

      if (process.env.NODE_ENV === 'production') {
        module.exports = require('./markerclusterer.cjs.production.js')
      } else {
        module.exports = require('./markerclusterer.cjs.development.js')
      }


//////////////////
// WEBPACK FOOTER
// ./~/@react-google-maps/marker-clusterer/dist/index.js
// module id = 142
// module chunks = 35675721766202